module.exports = __webpack_public_path__ + "img/19.f81f783d.jpg";